import { gray, orange } from './colors';
import { ThemeOptions } from './types';
import { ThemeDefinition } from 'vuetify/vuetify';

export const SYSDYNE_LIGHT_THEME_NAME: string = 'sysdyne-light';
export const SYSDYNE_DARK_THEME_NAME: string = 'sysdyne-dark';

//https://github.com/vuetifyjs/vuetify/blob/abcb3aad403357422623e992a61768543837105a/packages/vuetify/src/composables/theme.ts#L107
export const sysdyneLightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    background: '#efefef',
    error: '#ff5252',
    primary: orange.darken1,
    secondary: gray.darken4,
    'gray-darken-3': gray.darken3,
    'on-primary': gray.darken4,
  },
};

export const sysdyneDarkTheme: ThemeDefinition = {
  dark: true,
  colors: {
    error: '#ff5252',
    primary: orange.darken1,
    secondary: gray.darken4,
    surface: gray.darken4,
    'gray-darken-3': gray.darken3,
    'on-primary': gray.darken4,
  },
};

export const sysdyneTheme: ThemeOptions = {
  defaultTheme: SYSDYNE_LIGHT_THEME_NAME,
  themes: {
    [SYSDYNE_LIGHT_THEME_NAME]: sysdyneLightTheme,
    [SYSDYNE_DARK_THEME_NAME]: sysdyneDarkTheme,
  },
};
